import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Header from "../stories/components/Header.js";

export default function StorybookPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header title="Komponentbibliotek" lead="Vi jobber med nytt og universelt utformet komponentbibliotek" />
        <main>
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <p>STAF sitt komponentbibliotek kommer til å bygge på Digdirs designsystem, og er under utvikling.</p>
              </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}